import { LegacyAccountUser } from '@/api/queries/me/toLegacyAccountUser';
import { useAccountUsers } from '@/api/queries/me/useAccountUsers';
import { UserStatus } from '@payaca/types/userTypes';
import { useMemo } from 'react';

/** Every account user that is not deactivated — active, invited or unverified. */
export const useActiveAccountUsers = (): LegacyAccountUser[] => {
  const accountUsers = useAccountUsers();
  return useMemo(
    () => accountUsers.filter((u) => u.status !== UserStatus.DEACTIVATED),
    [accountUsers]
  );
};
